import { touchUserCenterHeartBeat } from "@/http/modules/login";

/**
 * 开启用户中心 心跳
 * @param {*} param0
 *  type: now-立即心跳
 */
export const startUserCenterHeartBeat = ({
  userId,
  loginRecord,
  time = 290000,
  type = "lazy"
}) => {
  // 开启心跳
  if (type === "now") {
    touchUserCenterHeartBeat({ userId, loginRecord }).then(res => {
      console.log("用户中心心跳：", res);
    });
  }
  if (!window.timeId) {
    console.log(">>>>>>>>开启心跳：");
    window.timeId = setInterval(() => {
      touchUserCenterHeartBeat({ userId, loginRecord }).then(res => {
        console.log("用户中心心跳：", res);
      });
    }, time);
  }
};

/**
 * 格式化列
 */
export const formatColumn = (prop, list, key = "value", value = "label") => {
  if (list instanceof Array) {
    const r = list.find(o => o[key] + "" === prop + "");
    return r && r[value];
  }
  return "";
};



// WEBPACK FOOTER //
// ./src/utils/serviceUtil.js